const SPREADSHEET_EXTENSIONS = new Set(['xlsx', 'xls', 'csv']);

export function isSpreadsheetDocumentPreview(
  extension: string,
  mimeType: string | null | undefined,
  previewPlainTextAsTable = false,
): boolean {
  if (
    previewPlainTextAsTable &&
    (extension === 'txt' || mimeType === 'text/plain')
  ) {
    return true;
  }
  return (
    SPREADSHEET_EXTENSIONS.has(extension) ||
    mimeType === 'text/csv' ||
    mimeType === 'application/csv'
  );
}
